module.exports = __webpack_public_path__ + "static/img/pt.fee5ea5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pt.png
// module id = Sbfu
// module chunks = 1